/* eslint-disable import/no-anonymous-default-export */

export default {
  MuiCssBaseline: {
    "@global": {
      "*::-webkit-scrollbar": {
        width: "8px !important",
        height: "8px !important",
      },
      "*::-webkit-scrollbar-thumb": {
        background: "#dadce2",
        borderRadius: "45px",
      },
      "@font-face": ["iranyekan"],
      ul: {
        direction: "ltr !important",
      },
      header: {
        boxShadow: "none !important",
      },
      '& img[src=""]': {
        display: "none",
      },
      "& input": {
        fontFamily: `iranyekan !important`,
        "&::placeholder": {
          fontFamily: `iranyekan !important`,
        },
      },
      "& $headerWrapper": {},
    },
  },
  MuiFormControl: {
    root: {
      width: "100%",
      marginTop: "5px",
    },
  },
  MuiInputLabel: {
    outlined: {
      transform: "translate(14px, 14px) scale(1)",
    },
  },
  MuiSelect: {
    root: {
      fontSize: "90%",
    },
    select: {
      "&:focus": {
        backgroundColor: "inherit",
      },
    },
  },
  MuiTableContainer: {
    root: {
      background: "transparent",
      boxShadow: "none",
    },
  },
  MuiTableCell: {
    root: {
      padding: "10px",
    },
  },
  MuiBackdrop: {
    root: {
      // backdropFilter: "blur(3px)",
      Transition: "unset !important",
    },
  },
  MuiFormHelperText: {
    contained: {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  MuiDialog: {
    container: {
      direction: "ltr",
    },
  },
  MuiSwitch: {
    switchBase: {
      "&.MuiIconButton-root": {
        padding: "9px 10px !important",
      },
    },
  },
  MuiTab: {
    root: {
      minWidth: "120px !important",
    },
  },
  MuiTabs: {
    root: {
      "& .Mui-selected": {
        position: "relative",
        "&:after": {
          position: "absolute",
          content: "''",
          width: "40%",
          display: "block",
          bottom: 0,
          height: "4px",
          borderRadius: "2px",
          backgroundColor: "#13d46c",
        },
      },
    },
  },
  PrivateTabIndicator: {
    root: {
      height: "4px",
      borderRadius: "10px",
    },
  },

  MuiList: {
    root: {
      "& .Mui-selected": {
        borderRight: "3px solid #13d46c",
      },
    },
  },

  MuiOutlinedInput: {
    root: {
      height: "48px",
      fontSize: "14px",
      lineHeight: "46px",
      borderColor: "#dadce2 !important",
      borderRadius: "8px",
      outline: "none !important",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#dadce2 !important",
      },
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#34bcee !important",
        },
      },
      "&:focus": {
        outline: "none !important",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#34bcee !important",
          boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
        },
      },
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#34bcee !important",
          borderWidth: "1px !important",
          boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
        },
      },
      "&.Mui-disabled": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#dadce2 !important",
        },
        "&:hover": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#dadce2 !important",
          },
        },
        "&:focus": {
          outline: "none !important",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#dadce2 !important",
            boxShadow: "none",
          },
        },
        "&.Mui-focused": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#dadce2 !important",
            boxShadow: "none",
          },
        },
      },
    },
    input: {
      height: "48px",
      lineHeight: "46px",
      padding: "0 24px",
      borderRadius: "8px",
      "&.Mui-disabled": {
        borderColor: "transparent !important",
        borderWidth: "1px !important",
        boxShadow: "none",
        backgroundColor: "#fafafb",
        color: "#6b718b !important",
      },
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 30px white inset !important",
        "&:hover": {
          WebkitBoxShadow: "0 0 0 30px white inset !important",
        },
        "&:focus": {
          WebkitBoxShadow: "0 0 0 30px white inset !important",
        },
        "&:active": {
          WebkitBoxShadow: "0 0 0 30px white inset !important",
        },
      },
    },
  },
};
